import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const REQUEST_USER_REQUESTS_EXPORT = gql`
  mutation RequestUserRequestsExport(
    $data: RequestExportInput!
    $filter: RequestUserExportFilterInput
  ) {
    requestUserRequestsExport(data: $data, filter: $filter) {
      message
    }
  }
`;
